// import createPersistedState from 'vuex-persistedstate'

const dashboard = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    numberCarouselVisible: 0 // 表示中のカルーセルのスライド番号(SP用)
  },
  getters: {
  },
  mutations: {
    setNumberCarouselVisible(state, numberCarouselVisible) {
      state.numberCarouselVisible = numberCarouselVisible
    }
  },
  actions: {
    // 表示中のカルーセルのスライド番号(SP用)
    setNumberCarouselVisible({ commit }, numberCarouselVisible) {
      commit('setNumberCarouselVisible', numberCarouselVisible)
    }
  }
}

export default dashboard
